import React from "react";
import AntTextArea from 'antd/lib/input/TextArea';
import useTheme from "../../hooks/useTheme";

export default function TextArea() {
  const [darkMode] = useTheme();
  return (
    <AntTextArea style={{ backgroundColor: darkMode ? "#141414" : "#ffffff" }} />
  );
};